import styled, { css } from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const ChatHeaderContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 64px;
    padding: 12px 20px;
    align-items: center;
    justify-content: center;
`

export const BackButtonContainer = styled.div`
    position: absolute;
    left: 20px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const BackButtonImg = styled.img`
    width: 24px;
    height: 24px;
`

export const HeaderSliderContainer = styled.div`
    height: 40px;
    width: 184px;
    background: #4f4f4f;
    border-radius: 26px;
    padding: 4px;
    display: flex;
`

export const SliderTab = styled.div`
    height: 32px;
    border-radius: 24px;
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 14px;
    color: #fff;
    ${({ isActive }) => {
        if (isActive) {
            return css`
                background: #222222;
                box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.6);
                font-weight: 600;
            `
        }
    }}
`

export const ChatFooterContainer = styled.div`
    padding: 14px 24px 24px 24px;
`

export const TextInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding: 8px 20px;
    position: relative;
    width: 100%;
    align-self: flex-end;
    background: #808080;
    border-radius: 8px;
    overflow: auto;

    & > textarea {
        display: flex;
        flex: 1;
        justify-content: flex-start;
        align-items: center;
        overflow-y: auto;
        border: none;
        outline: none;
        resize: none;
        word-wrap: break-word;
        height: 20px;
        padding: 0px;
        font-family: 'Avenir', 'AvenirBold', 'AvenirItalic';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: -0.01em;
        background: inherit;
        color: #fff;
    }
    & > textarea::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.6);
        font-family: 'Avenir', 'AvenirBold', 'AvenirItalic';
    }
    & > textarea::-moz-placeholder {
        color: rgba(255, 255, 255, 0.6);
        font-family: 'Avenir', 'AvenirBold', 'AvenirItalic';
    }
`

export const TextInputArea = styled.textarea``

export const SendButton = styled.div`
    display: flex;
    margin-left: 6px;
`

export const SendButtonImg = styled.img`
    display: flex;
    align-self: flex-end;
    height: 24px;
    width: 24px;
`

export const ChatFeedContainer = styled.div`
    display: flex;
    flex: 1;
    position: relative;
    overflow: hidden;
`

export const ChatFeedInnerContainer = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: auto;
    flex-direction: column;
    justify-content: flex-end;
    color: #fff;
    padding: 0px 20px;
`

export const TextMessageContainer = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: ${({ isSelf }) => (isSelf ? 'row-reverse' : 'row')};
    margin-top: ${({ isContinued }) => (isContinued ? '4px' : '12px')};
`

export const AvatarContainer = styled.div`
    width: 42px;
    height: 42px;
`

export const MessageContainer = styled.div`
    min-height: 48px;
    max-width: 70%;
    margin: 0px 12px;
    background: ${({ isSelf }) => (isSelf ? '#4f4f4f' : 'rgba(0, 0, 0, 0.8)')};
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    padding: 8px 12px;
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
    ${({ isGesture }) => {
        if (isGesture) {
            return css`
                font-size: 20px;
                line-height: 35px;
            `
        }
    }}
`

export const MessageHeader = styled.div`
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    color: #84ade1;
    margin-bottom: 4px;
    text-align: left;
`

export const MessageFooter = styled.div`
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    color: #b4b4b4;
    margin-top: 4px;
    text-align: right;
`

export const ChatPreviewContainer = styled.div`
    position: absolute;
    left: 0px;
    bottom: 75px;
    flex-direction: column;
    justify-content: flex-end;
    color: #fff;
    padding: 0px 20px;
    display: ${({ shouldShow }) => (shouldShow ? 'flex' : 'none')};
    transition: display 0.4s ease-out;
`
